<template lang="pug">
  #action-group.right-panel.md-elevation-1.md-scrollbar.md-theme-default
    .md-layout-row.header
      .md-flex
          md-button.md-icon-button.md-dense.close.small(v-bind:to="{ name: 'Actions', params: { code: $route.params.code}, query: $route.query}"): md-icon close
          .md-body-1(v-if="action") {{action.name}}
    .md-caption Группы:
        md-chip.small(v-for="group in groups" v-bind:key="group.id" md-deletable @md-delete="removeUserGroupFromAction(group.code)") {{group.name}}
        md-button.md-icon-button.small.add(@click="showAddGroupSelect = true" href="#"): md-icon add
    .md-flex(v-show="showAddGroupSelect")
      md-field(md-theme="white" v-if="usersGroups.length")
        label(for="add-groups") Выберете группу
        md-select#add-groups(name="movies" v-model="addGroups")
          md-option(v-for="group in usersGroups" v-bind:key="group.id" v-bind:value="group.code") {{group.name}}
        md-button.md-icon-button.md-dense(@click="postUserGroupToAction()"): md-icon done
        md-button.md-icon-button.md-dense(@click="showAddGroupSelect = false"): md-icon close
</template>

<script>
  import ModuleMenu from './menu.vue';

  export default {
      data() {
          return {
            addGroups: '', //группа, которую надо добавить к действию
            showAddGroupSelect: false,
            action: {
              name: '',
            }
          }
      },
      components: {
        ModuleMenu
      },
      computed: {
        groups() { //группы пользователей, добавленные к выбранному действию
          return this.$store.state.module.action_group;
        },
        module() { //все модули в системе
          return this.$store.state.module.module;
        },
        actions() { //все действия пользователей
          return this.$store.state.module.actions;
        },
        usersGroups() { //все групппы пользователей
          return this.$store.state.users.groups;
        },
      },
      watch: {
        '$route.params.action_code'() {
          this.$store.commit('openRightPanel');
          this.getModuleActionGroup();
          this.getAction();
        },
        'actions'() {
          this.getAction();
        }
      },
      created() {
        this.getModuleActions();
        this.getModuleActionGroup();
        this.getUserGroups();
        this.$store.commit('openRightPanel');
      },
      methods: {
        removeUserGroupFromAction (groupCode) {
          let data = {};
          data.group_code = groupCode;
          data.module_code = this.$route.params.code;
          data.name = this.$route.params.action_code;
          this.$store.dispatch('module/removeUserGroupFromAction', data);
        },
        postUserGroupToAction() { //добавляем группу пользователей к выбранному действию
          let data = {};
          data.group_code = this.addGroups;
          data.module_code = this.$route.params.code;
          data.name = this.action.code;
          data.description = this.action.name;
          data.sort = 100;
          this.$store.dispatch('module/postUserGroupToAction', data);
          this.showAddGroupSelect = false;
        },
        getUserGroups() { //получение всех групп пользователей
          if (!this.$store.state.users.groups.length) {
            this.$store.dispatch('users/getUsersGroups');
          }
        },
        getModuleActionGroup() { //получаение групп уже добавленных к выбранному действию
            this.$store.dispatch('module/getModuleActionGroup', this.$route.params.code);
        },
        getModuleActions() { //получение списка действий модуля
            this.$store.dispatch('module/getModuleActions', this.$route.params.code).then(() => {
              this.getAction();
            });
        },
        getAction() { //получение выбранного действия
          this.action = this.actions[this.$parent.$route.params.action_code];
        }
      }
  }
</script>



// WEBPACK FOOTER //
// Action.vue?a4111a5a